import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { catalogReturnPath, restoreCatalogPosition } from '../lib/gameLaunch';
import { bootTelegramShell, getTelegramWebApp } from '../telegram/webapp';

export function useTelegramChrome() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    bootTelegramShell();
  }, []);

  useEffect(() => {
    const tg = getTelegramWebApp();
    const back = tg?.BackButton;
    if (!back) return;
    const atHome = location.pathname === '/';
    const onPlay = location.pathname.startsWith('/play/');
    const onBack = () => {
      if (onPlay) {
        navigate(catalogReturnPath());
        restoreCatalogPosition();
        return;
      }
      if (window.history.length > 1) navigate(-1);
      else navigate('/', { replace: true });
    };
    if (atHome) {
      back.hide();
      return;
    }
    back.onClick(onBack);
    back.show();
    return () => {
      back.offClick(onBack);
      back.hide();
    };
  }, [location.pathname, navigate]);
}
